import Hidden from '@material-ui/core/Hidden';
import React from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";

import bgHeaderImage from "assets/EnergyCompany/img/bg-header.png";
import buttonBlue from "assets/EnergyCompany/jss/button-blue.jsx";
import centerStyle from "./center";
import ipad from "assets/EnergyCompany/img/ipad.png";
import logo from "assets/EnergyCompany/img/logo-branca.svg";

const style = theme => ({
  button: { ...buttonBlue },
  buttonGreen: {
    ...buttonBlue,
    backgroundColor: "#4CAF50",
    fontWeight: "bold",
  },
  centeredSection: {
    ...centerStyle(theme),
    padding: "20px 0",
  },
  disclaimer: {
    color: "white",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
    gridColumnGap: "30px",
  },
  disclaimerText: {
    "& h1": {
      fontWeight: "bold",
    },
    "& p": {
      fontSize: "20px",
      lineHeight: "1.5",
    },
    [theme.breakpoints.down("sm")]: {
      textAlign: "center",
      "& h1": {
        fontSize: "2.5em",
      },
    },
  },
  ipad: {
    marginTop: "100px",
    "& img": {
      width: "100%",
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "20px",
    },
  },
  li: {
    color: "white",
    display: "inline-block",
    fontWeight: "bold",
    listStyle: "none",
    marginLeft: theme.spacing.unit * 2,
    textTransform: "uppercase",
    "& a": {
      color: "white",
    },
    "& a:hover": {
      color: "white",
    },
  },
  linksWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "space-between",
  },
  logo: {
    width: "150px",
  },
  main: {
    backgroundImage: `url(${bgHeaderImage})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "440px",
  },
});

const Header = ({ classes, history, user }) => (
  <main className={classes.main}>
    <div className={classes.centeredSection}>
      <div className={classes.linksWrapper}>
        <img alt="Logo" className={classes.logo} src={logo} />
        <ul>
          <Hidden smDown>
            <li className={classes.li}>
              <a href="/area-aberta/simulador-cativo-livre">Simuladores</a>
            </li>
            <li className={classes.li}>
              <a href="/planos">Planos</a>
            </li>
            <li className={classes.li}>
              <a href={"#sobre-nos"}>Sobre Nós</a>
            </li>
            <li className={classes.li}>
              <a href={"#contato"}>Contato</a>
            </li>
          </Hidden>
          <li className={classes.li}>
            {user.access_token ? (
              <button className={classes.button} onClick={() => history.push("/dashboard")}>
                DASHBOARD
              </button>
            ) : (
              <button className={classes.button} onClick={() => history.push("/login")}>
                LOGIN
              </button>
            )}
          </li>
          <li className={classes.li}>
            <button className={classes.buttonGreen} onClick={() => history.push("/cadastro")}>
              CADASTRE-SE
            </button>
          </li>
        </ul>
      </div>
      <div className={classes.disclaimer}>
        <div className={classes.disclaimerText}>
          <h1>Ser digital é inevitável</h1>
          <Hidden smDown>
            <p>A Energy Company é a única plataforma de suporte aos</p>
            <p>agentes do mercado de energia que consolida informações</p>
            <p>essenciais para tomada de decisão de forma rápida e</p>
            <p>objetiva.</p>
          </Hidden>
          <Hidden mdUp>
            <p>O mercado de energia está se desenvolvendo como nunca e precisa de uma plataforma que acompanhe essa evolução. Com a Energy Company é possível analisar de forma estratégica as principais informações.</p>
          </Hidden>
        </div>
        <div className={classes.ipad}>
          <img alt="iPad" src={ipad} />
        </div>
      </div>
    </div>
  </main>
);

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  user: PropTypes.object.isRequired,
};

export default withStyles(style)(Header);



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/1-header.js